import countries from '@/core/country.json';

const countriesFrozen = Object.freeze(countries);
export const ADDRESS_FIELDS_AU = Object.freeze([
  {
    name: 'addressLines',
    value: '',
    label: 'Street Address',
    isInvalid: null,
    theType: 'text',
    validation: {
      errorMessage: 'Enter valid street address',
    },
  },
  {
    name: 'locality',
    value: '',
    label: 'City',
    isInvalid: null,
    theType: 'text',
    validation: {
      errorMessage: 'Enter valid city',
    },
  },
  {
    name: 'administrativeArea',
    value: '',
    label: 'State',
    isInvalid: null,
    theType: 'text',
    list: [
      {
        id: 1,
        code: 'ACT',
        description: 'Australian Capital Territory',
      },
      {
        id: 2,
        code: 'NSW',
        description: 'New South Wales',
      },
      {
        id: 3,
        code: 'NT',
        description: 'Northern Territory',
      },
      {
        id: 4,
        code: 'QLD',
        description: 'Queensland',
      },
      {
        id: 5,
        code: 'SA',
        description: 'South Australia',
      },
      {
        id: 6,
        code: 'TAS',
        description: 'Tasmania',
      },
      {
        id: 7,
        code: 'VIC',
        description: 'Victoria',
      },
      {
        id: 8,
        code: 'WA',
        description: 'Western Australia',
      },
    ],
    validation: {
      errorMessage: 'Select a state',
    },
  },
  {
    name: 'regionCode',
    value: 'Australia',
    code: 'AU',
    label: 'Country',
    isInvalid: false,
    list: countriesFrozen,
    theType: 'text',
    validation: {
      errorMessage: 'Select a country',
    },
  },
  {
    name: 'postalCode',
    value: '',
    isInvalid: null,
    label: 'Postcode',
    theType: 'number',
    validation: {
      errorMessage: 'Enter valid postcode',
    },
  },
]);
